import { UnsavedChange } from 'src/app/state/unsaved-changes.reducer';
import { LoadingState } from 'src/app/utilities/state.util';
import { SimilarJobsQuery } from 'src/generated/graphql.generated';

export interface ContinueJobConfirmDialog {
    visible: boolean;
    jobId: string | null;
    zoneId: string | undefined;
    doNotAskAgain: boolean;
    changes: UnsavedChange[];
}

export const newOpportunitySimilarJobsInitialState = {
    jobs: [] as NonNullable<SimilarJobsQuery['searchJobs']['results'][number]>[],
    query: '' as string,
    loading: LoadingState.INIT as LoadingState,
    showMore: false as boolean,
    // `search.searchJobs` is not granted to crew roles: the ES-backed search
    // spans every job in the zone and would leak other customers' names to
    // users restricted to their own jobs. The widget hides itself instead.
    permissionDenied: false as boolean,
    continueJobConfirmDialog: {
        visible: false,
        jobId: null,
        zoneId: undefined,
        doNotAskAgain: false,
        changes: []
    } as ContinueJobConfirmDialog,
};

export type NewOpportunitySimilarJobsState = typeof newOpportunitySimilarJobsInitialState;
